import {canUseHint, getCurrentAction, getCurrentScenario} from "../selectors";
import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import {analyticsSendEvent} from "../../../libs/analytics";
import getCurrentActionAttempts from "../selectors/getCurrentActionAttempts";
import {EducationSessionErrorReason} from "../../../schema";
import {_next, getBranch, getBranchActions} from "../utils";

export default function skipError() {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();

    const action = getCurrentAction(state)!;

    const showHint = getCurrentActionAttempts(state) === 2 && canUseHint(state);

    analyticsSendEvent("playerSkipError", {
      sessionId: state.sessionId!,
      actionId: action.id,
      showHint,
    });

    if (showHint && !state.isAutoUseHintOffered) {
      dispatch({
        type: "hint",
        payload: {
          actionId: action.id,
          isAutoUseHintOffered: true,
        },
      });
    }

    const lastUserInputError = state.lastUserInputResult?.errorState;

    dispatch({
      type: "update",
      payload: {
        lastUserInputResult: null,
      },
    });

    if (state.branchId && lastUserInputError === EducationSessionErrorReason.WRONG_CHOICE) {
      const rootAction = getCurrentScenario(state).actions[state.index];
      const branch = getBranch(rootAction, state.branchId);
      const branchActions = branch ? getBranchActions(branch) : [];
      const nextBranchIndex = branchActions ? _next(branchActions, state.level, state.branchIndex!) : undefined;

      if (nextBranchIndex === undefined && branch?.targetScenarioId) {
        dispatch({
          type: "startScenario",
          payload: {
            scenarioId: branch.targetScenarioId,
            branchId: branch.id,
          },
        });
        return;
      }

      dispatch({
        type: "next",
      });
    }
  };
}
